var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduled-email-listing" },
    [
      _vm.isScheduledEmailsFeatureEnabled
        ? [
            _vm.isLoading
              ? _c("TableLoading")
              : [
                  _c("EmailListingSettingsHeader", {
                    ref: "ScheduledEmailsTable",
                    staticClass: "scheduled-email-listing__settings-header",
                    attrs: {
                      columns: _vm.columns,
                      totalEmails: _vm.formattedEmails.length
                    }
                  }),
                  _vm._v(" "),
                  _c("EmailListingTable", {
                    staticClass: "scheduled-email-listing__table",
                    attrs: { columns: _vm.columns, emails: _vm.formattedEmails }
                  })
                ]
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }